import { __awaiter, __generator } from "tslib";
import { fetchSFCCSetting } from '@gn-audio/core/api/site-settings';
import { bootstrapSFCCBasket } from './bootstrap-sfcc-basket';
import { canBootstrapSFCCBasket } from './can-bootstrap-sfcc-basket';
/**
 * Checks whether SFCC Basket could be bootstraped and bootstraps in case of true result.
 */
export var bootstrapSFCCBasketIfPossible = function () { return __awaiter(void 0, void 0, void 0, function () {
    var _a;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0: return [4 /*yield*/, canBootstrapSFCCBasket()];
            case 1:
                if (!(_b.sent())) {
                    return [2 /*return*/];
                }
                _a = bootstrapSFCCBasket;
                return [4 /*yield*/, fetchSFCCSetting()];
            case 2: return [4 /*yield*/, _a.apply(void 0, [_b.sent()])];
            case 3:
                _b.sent();
                return [2 /*return*/];
        }
    });
}); };
